import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IMspDashboard } from '../models/msp-dashboard';

@Injectable({
  providedIn: 'root',
})
export class ManagedServicesSharedDataService {
  dashboards$ = new BehaviorSubject<IMspDashboard[]>([]);
  filters: {
    boardNames: string[];
    statusesGroup: string[];
    priorityIds?: number[];
    createdAfter: string;
    createdBefore: string;
    closedAfter?: string;
    closedBefore?: string;
    summary?: string;
    relationship?: string;
  };

  constructor() {
    this.filters = {
      boardNames: [],
      statusesGroup: [],
      priorityIds: [],
      createdAfter: '',
      createdBefore: '',
      closedAfter: '',
      closedBefore: '',
      summary: '',
      relationship: '',
    };
  }

  resetFilters(): void {
    this.filters = {
      boardNames: [],
      statusesGroup: [],
      priorityIds: [],
      createdAfter: '',
      createdBefore: '',
      closedAfter: '',
      closedBefore: '',
      summary: '',
      relationship: '',
    };
  }

  getFilters() {
    const activeFilters = {};

    for (const filter in this.filters) {
      if (
        this.filters[filter] !== null &&
        this.filters[filter] !== undefined &&
        this.filters[filter] !== '' &&
        !(Array.isArray(this.filters[filter]) && this.filters[filter].length === 0)
      ) {
        activeFilters[filter] = this.filters[filter];
      }
    }

    return activeFilters;
  }
}
